import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
@Component({
  selector: 'app-addleavesalary',
  templateUrl: './addleavesalary.component.html',
  styleUrls: ['./addleavesalary.component.css']
})
export class AddleavesalaryComponent implements OnInit,ComponentCanDeactivate {
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "Leavesalary";
  //Display
  formmode:string="Add";
  
   //Mode Values
   isaddmode:boolean=false;
   iseditmode:boolean=false;
   isdeletemode:boolean=false;
   isviewmode:boolean=false;
   isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  
   isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   
  
   isshowattachment: boolean = false;
   attachmentcount: number = 0;

   ismanualclose: boolean;
  
   isemploading: boolean=false;

   checkfeildmsg: any = "";
        //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
   //Save Validation
   submitted:boolean;
   successfully:boolean;
   saveloading: boolean;
   //Edit Get Values
   leavesalaryColl:any=[];
   leavesalaryBO:any={};

   leavesalaryid:number=0
   
   //leavetypeColl:any=[];
  empColl: any = [];
  
  empBO:any={}

   leavesalaryform=new FormGroup({
    leavesalaryid:new FormControl(0),          
    empid:new FormControl(null,Validators.required),  
    transdt:new FormControl(null,Validators.required), 
    effectivedt:new FormControl(null,Validators.required), 
    amount:new FormControl(''),   
    descr:new FormControl(''),  
    inactive:new FormControl(false),  
   });
  
   dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
      public router: Router,private toastr: ToastrService, private productFindService: NgbModal,private datePipe: DatePipe) { 
        this.route.queryParams.subscribe(params => {
          if(params.id!==undefined){
            this.leavesalaryid = params.id
          }          
        });
        this.fnGetParameterVariable();
        this.fnServiceChanges();
        this.dateCustomClasses = [
          { date: new Date(), classes: ['bg-warning'] },
        ];
  }
    //Get Para
fnGetParameterVariable() {
  this.route.queryParams.subscribe(params => {
    if (params.empid !== undefined) {
      this.filteremployeeid = params.empid
    }

    if (params.empname !== undefined) {
      this.filteremployeename = params.empname
    }

    if (params.status !== undefined) {
      this.filterstatus = params.status
    }

    if (params.fromdate !== undefined) {
      this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
    }

    if (params.todate !== undefined) {
      this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
    }
  })
} 

    
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
  
    });
  }
  
  
  
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
  
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnOnInitForm() {
      try{
          this.isaddmode=true;
          this.leavesalaryform.reset();
          this.fnInitializeFormGroup(); 
  
          if(this.leavesalaryid>0){
            this.fngetLeavesalary();
          }
          //this.fngetLeaveType();
          this.fngetEmployee();

      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.leavesalaryid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
  
    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    return _check;
  }
  
  fnUserFailedForm() {
    this.isprivilage = true;
  }  
  fnInitializeFormGroup(){
      this.leavesalaryform.setValue({
        leavesalaryid:0,          
        empid:null,  
        transdt:new Date(),
        effectivedt:new Date(),
        amount:null,    
        descr:'',  
        inactive:false              
      })
  }

  
  fngetEmployee() {   
    this.isemploading=true;   
    var data = {
        'empid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getEmpListView(data)
    .subscribe(
        (res)=>{   
          this.isemploading=false;                  
          if(res.json().status===200){
            this.empColl = res.json().result;          
            this.fnChangeEmpLookup()
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{        
          this.isemploading=false;         
            this.toastr.error('Error', err);
    })
  }


  //Get 
  fngetLeavesalary() {
    if (this.showProgress) {
      return;
    }         
        var data = {
          'leavesalaryid':this.leavesalaryid,
          'companyid':this.loginService.fnGetCompanyId()          
        }
        this.appService.getLeavesalary(data)
        .subscribe(
          (res)=>{                
            if(res.json().status===200){ 
              this.fnHideProgress();
 
              this.leavesalaryColl=res.json().result;
              var editdata = this.leavesalaryColl[0];        
              this.fnEditMode(editdata);
              this.leavesalaryBO=editdata;
            }
            else {
              this.fnHideProgress();

              this.loginService.fnAPIError(res.json())
            }
            
        },
        (err)=>{ 
          this.fnHideProgress();
         
          this.toastr.error('Error', err);
        })
  }
  
  
  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.leavesalaryform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  fnResetValidation() {
    if (this.loginService.fnCheckFornControlNotfound(this.leavesalaryform.get('effectivedt'))) {
      this.leavesalaryform.controls['effectivedt'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.leavesalaryform.get('inactive'))) {
      this.leavesalaryform.controls['inactive'].setErrors(null);
    }
  }

  fnSetValidation() {
    let _ischeck = false;
    if (this.loginService.fnCompareDateValidation(this.leavesalaryform.get('effectivedt').value, this.leavesalaryform.get('transdt').value)) {
      this.leavesalaryform.controls['effectivedt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    return _ischeck;
  }


  
  
  //Save Btn Click
  fnSaveBtnClick(){
      try{ if (this.saveloading) {
        return;
      }

        this.submitted=true;
        this.successfully=false;

        this.fnResetValidation()
        //Validate
        if (this.leavesalaryform.valid) {
  
          if (this.fnSetValidation()) {
            return;
          }
         this.saveloading = true;
            //Check
            var data = {
                  'leavesalaryid': this.leavesalaryid,                      
                  'transdt':this.fnFormatDatetime(this.leavesalaryform.get('transdt').value), 
                  'effectivedt':this.fnFormatDatetime(this.leavesalaryform.get('effectivedt').value), 
                  'empid':this.leavesalaryform.get('empid').value,
                  'amount':this.leavesalaryform.get('amount').value,       
                  'descr':this.leavesalaryform.get('descr').value,                  
                  'inactive':this.leavesalaryform.get('inactive').value,            
                  'companyid':this.loginService.fnGetCompanyId(),
                  'createdby': this.loginService.fnGetModUserId(),  
                  'modifiedby':this.loginService.fnGetModUserId(),                                                              
            }
  
          
         
            this.appService.fnCheckLeavesalary(data).subscribe(
              (res) => {
                if (res.json().status === 200) {
                  var _checkresponce = res.json().result[0];
    
                  var _checkresult =_checkresponce.checkfield;
    
                  if (_checkresult === 'done') {
                    if (this.leavesalaryform.get('leavesalaryid').value > 0) {
                      //Update 
                      this.fnSetLeavesalary(data);
                    }
                    else {
                      //Insert 
                      this.fnInsertLeavesalary(data);
                    }
                  }
                  else {
                    if (_checkresult === "COMMON") {                  
    
                      this.checkfeildmsg = _checkresponce.checkvaluemsg;
    
                      this.leavesalaryform.controls['inactive'].setErrors({ 'notfound': true });
                    }
                  }                  
                }
                else {
                  this.loginService.fnAPIError(res.json())
                }
              },
              (err) => {
                this.toastr.error('Error', err);
              });
            
          
    
          }
        } catch (ex) {
          this.fnShowErrorMsg(ex);
        }
      }
    
  
  //Insert
  fnInsertLeavesalary(data){    
    
      this.appService.fnInsertLeavesalary(data).subscribe(
        (res)=>{
          this.saveloading = false;
          if(res.json().status===200){  
            if(res.json().result!=""){
              this.toastr.success('', "The new leavesalary has been added successfully.Insert Successfully");
              this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
              this.ismanualclose=true;
              this.fnCloseForm();      
              // var _result = res.json().result;

              // if (_result.length > 0) {
              //   var resdata = _result[0];
              //   if (resdata.length > 0) {
              //     this.fnAttachmentSave(resdata[0].leavesalaryid);
              //   }
              // }      
                      }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
      },
        (err)=>{
          this.saveloading = false;
          this.toastr.error('Error', err);
        });
  
  }
  
  //Set
  fnSetLeavesalary(data){    
  
  this.appService.fnSetLeavesalary(data).subscribe(
    (res)=>{
      this.saveloading = false;
      if(res.json().status===200){
      console.log(res.json().result);  
            if(res.json().result!=""){
                this.toastr.success('', "The leavesalary has been updated successfully.");
                this.fnInsertActivityLog('EDIT',this.leavesalaryid,this.fngetDescriptionRefno(data));
                this.ismanualclose=true;
                this.fnCloseForm();      
            } 
        }
      else {
        this.loginService.fnAPIError(res.json())
      }
    },
    (err)=>{
      this.saveloading = false;
      this.toastr.error('Error', err);
    });
  
  }
  fnEmployeeSearchFn(term: string, item: any) {  
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  }

  
  //Close
  async fnCloseForm(){
  try{
    if ((this.isaddmode || this.iseditmode)&& !this.ismanualclose) {
      var a = await this.loginService.fnConfirmFormLeave();
      if (a === false) {
        return false;                
      }
    }

    this.ismanualclose = true;
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'status': this.filterstatus,
        'empid': this.filteremployeeid,
        'empname': this.filteremployeename,
        'fromdate': this.fnFormatDatetime(this.filterfromdate),
        'todate': this.fnFormatDatetime(this.filtertodate),
      }
    }

    this.router.navigate(['/Leavesalary'], navigationExtras);
    
  }catch(ex){
      this.fnShowErrorMsg(ex);
  }
  }
  fnEditBtnClick() {
    this.iseditmode=true;
    this.isviewmode=false;
  }
  private fnEditMode(deptBO){
    
    deptBO.transdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.effectivedt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));

    this.leavesalaryform.setValue({ 
      leavesalaryid:deptBO.leavesalaryid,     
      empid:deptBO.empid,
      transdt:deptBO.transdt,
      effectivedt:deptBO.effectivedt,
      amount:deptBO.amount,
      descr:deptBO.descr,
      inactive:deptBO.inactive
    });
  
    this.formmode="Edit";
     
    this.isaddmode=false;
    this.iseditmode=false;
    this.isdeletemode=false;
    this.isviewmode = true;
    
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();
  }
  
  
   //#Attachment
fnAttachmentBtnClick() {
 
  const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
  modalRef.componentInstance.formname = this.formname;
  modalRef.componentInstance.trxid = this.leavesalaryid;
  modalRef.componentInstance.formmode = "EDIT";
  modalRef.componentInstance.fnGetAttachment();


  modalRef.result.then(() => {
    this.fnGetAttachmentCount()
  }, () => {
    this.fnGetAttachmentCount()
  })


  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
    if (receivedEntry === 'DONE') {
      this.fngetLeavesalary();
    }
    this.fnGetAttachmentCount()
  });

}


fnAttachmentSave(tid) {

  // if (this.attachmentcount > 0) {
    
  //   this.attachmentbar.formtype = this.formname;    
  //   this.attachmentbar.trxid = tid;    
  //   this.attachmentbar.formmode = "ADD";
    
  //   this.attachmentbar.fnSaveAttachmentByAddMode();
  // }
  // else {
  //   this.fnCloseForm();
  // }

}

fnSetAttachmentCount(data) {
  
  this.attachmentcount = data;
}

  
   //Approvals POP
   fnShowApprovalPop(stauts) {
    
    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.leavesalaryid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetLeavesalary();
      }
      

    });
  }

  

  //Attachment
  fnGetAttachmentCount() {
    if (this.leavesalaryid > 0) {
      var data = {
        'trxid': this.leavesalaryid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }


  
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }

  fnConvertDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        var dateParts = dt.split("-");
        var sdate =new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]+1); 
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }
      
      }else {
      return null
    }
   
  }
  fngetDescriptionRefno(data){
    var rtnstr="";
    try{
        if(data.transdt){
          rtnstr=rtnstr+data.transdt;
        }
  
        if(data.empid){
          rtnstr=rtnstr+" - "+data.empid;
        }
  
        if(data.empname){
          rtnstr=rtnstr+" - "+data.empname;
        }
      }catch{
      
      }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }
  
  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
        logby:this.loginService.fnGetModUserId(),
      }
    
  
      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{
       
        });
  
    }catch{
  
    }
  } 
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }  

  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  


}
